import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-047941ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "import-icon zkfont-upload" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "import-text" }, "点击或将文件拖拽到这里上传", -1))
const _hoisted_3 = { class: "import-tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支持扩展名：.xsl", -1))

import type { UploadInstance, UploadProps, UploadRawFile, UploadRequestOptions } from 'element-plus'
import { ElLoading, ElMessage } from 'element-plus'
import { computed, ref } from 'vue'
import { genFileId } from 'element-plus'
import { downloadFile } from '@tri-admin/utils/src/download'
interface Props {
  data?: Record<string, string | number>
  name?: string
  limit?: number
  visible: boolean
  request: (data: any) => Promise<any>
  refresh: () => Promise<any>
  multiple?: boolean
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetImportV2' },
  __name: 'widget-importV2',
  props: {
    data: {},
    name: { default: 'file' },
    limit: { default: 1 },
    visible: { type: Boolean, default: false },
    request: {},
    refresh: {},
    multiple: { type: Boolean, default: false }
  },
  emits: ['download', 'update:visible', 'finish'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const count = ref(0)
const isError = ref(false)


const showed = computed<boolean>({
  get: () => props.visible,
  set: (val) => emits('update:visible', val),
})
const loading = ref()
const uploadRef = ref<UploadInstance>()
const onChange = (data: any, list: any[]) => (count.value = list.length) // 上传数量
const onError = (error: any) => {
  console.log(error)
  clear()
} // 上传错误

// 取消按钮关闭
function onCancel() {
  clear()
  isError.value = false
}
// 还原数据
function clear() {
  count.value = 0
  uploadRef.value?.clearFiles()
  loading.value?.close()
}
//当文件超出替换
const handleExceed: UploadProps['onExceed'] = (files) => {
  uploadRef.value?.clearFiles()
  const file = files[0] as UploadRawFile
  file.uid = genFileId()
  uploadRef.value?.handleStart(file)
}

// 提交
function onSubmit() {
  if (count.value <= 0) return ElMessage.warning('请先选择导入文件！')
  loading.value = ElLoading.service({ lock: true, text: '正在导入中...', background: 'var(--el-overlay-color-light)' })
  uploadRef.value?.submit()
}
let errorBlob = ''
// 上传成功
function onSuccess() {
  clear()
  props?.refresh()
  if (errorBlob) {
    isError.value = true
    ElMessage.error('导入失败,请点击下载失败文件查看失败原因！')
  } else {
    isError.value = false
    errorBlob = ''
    emits('update:visible', false)
    emits('finish')

    ElMessage.success('全部数据导入成功!')
  }
}

function dataFormatter(options: UploadRequestOptions) {
  const { data, name } = props
  const formData = new FormData()
  formData.append(name, options.file)
  if (data) {
    const items = Object.entries(data)
    items.forEach(([key, val]: [string, string | number]) => formData.append(key, String(val)))
  }
  return formData
}

async function httpRequest(options: UploadRequestOptions) {
  if (!props.request) return
  const formData = dataFormatter(options)
  const requestApi = props.request
  try {
    const data = await requestApi(formData)
    if (data?.size) {
      errorBlob = data
    } else {
      errorBlob = ''
    }
  } catch (error: any) {
    console.error(error)
  }
}

const downloadFileError = () => {
  downloadFile(errorBlob, { type: 'application/vnd.ms-excel' }, '导入失败文件')
}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_tri_dialog = _resolveComponent("tri-dialog")!

  return (_openBlock(), _createBlock(_component_tri_dialog, {
    show: showed.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showed).value = $event)),
    size: "mini",
    title: "导入",
    class: "import-mode",
    footer: true,
    "lock-scroll": false,
    onCancel: onCancel,
    onConfirm: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_upload, {
        name: _ctx.name,
        data: _ctx.data,
        limit: _ctx.limit,
        "http-request": httpRequest,
        "auto-upload": false,
        "on-change": onChange,
        "on-success": onSuccess,
        "on-error": onError,
        ref_key: "uploadRef",
        ref: uploadRef,
        class: "import-view",
        accept: ".xls,.xlsx",
        "on-exceed": handleExceed,
        multiple: _ctx.multiple,
        drag: ""
      }, {
        tip: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('download')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("模板下载")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }, 8, ["name", "data", "limit", "multiple"]),
      (isError.value)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "失败文件："
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                type: "danger",
                onClick: downloadFileError
              }, {
                default: _withCtx(() => [
                  _createTextVNode("点击下载")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})